import React from 'react';
import cx from 'classnames';

import { IconLightning } from '..';

interface InsightsIndexLogoProps {
    addClasses?: string;
    showLightning: boolean;
}

export const InsightsIndexLogo = ({
    addClasses,
    showLightning,
}: InsightsIndexLogoProps): JSX.Element => (
    <span className={cx('text-primary-500', addClasses)}>
        {showLightning && <IconLightning fillColor="primary-500" width={24} />}
        TrqkIQ Insights Index&#8482;
    </span>
);
